import PropTypes from 'prop-types'
import LoadingText from '@/components/shared/LoadingText'
import composesStyles from '@/styles/_settings/composes.module.css'

const Send = ({sentences}) => (
  <div
    className={`${composesStyles.animation_enterfrombottom} ${composesStyles.paddingx} ${composesStyles.fullmaxwidth}`}
  >
    <LoadingText sentences={sentences} />
  </div>
)

Send.defaultProps = {
  sentences: ['Enviando os seus dados...', 'Aguarde um momento...']
}

Send.proptypes = {
  sentences: PropTypes.arrayOf(PropTypes.string)
}

export default Send
